import { ComponentPropsWithoutRef, ReactNode } from 'react';

import { Colors } from '@sternum/web/components/theme/constants';

import { TimelineSystemProps } from './TimelineGraph.types';

import { TimelinePointSelected, TimePointContent, TimePointStyled } from './TimelineGraph.styles';

export interface TimePointProps extends TimelineSystemProps, ComponentPropsWithoutRef<'div'> {
  color?: string;
  isSelected?: boolean;
  children?: ReactNode;
}

export function TimePoint({ children, color = Colors.OrangeMiddle, isSelected, ...props }: TimePointProps) {
  return (
    <TimePointStyled aria-selected={isSelected} backgroundColor={color} {...props}>
      <TimelinePointSelected />
      <TimePointContent>{children}</TimePointContent>
    </TimePointStyled>
  );
}
